module.exports = __webpack_public_path__ + "static/media/instagram-relax-tablet.815ecac3.webp";